import { useEffect } from "react";
import { LoadingCardSkeleton } from "../../../../components/ui/skeleton-loaders";
import { useToast } from "../../../../hooks/use-toast";
import { EditFranquiaDialog } from "./components/edit-franquia-dialog";
import { FranquiasTable } from "./components/franquias-table";
import { RegistrationForm } from "./components/registration-form";
import { useImileCadastroFranquia } from "./hooks/use-imile-cadastro-franquia";

export default function ImileCadastroFranquias() {
  const { toast } = useToast();
  const {
    registrationForm,
    editForm,
    franquias,
    isLoading,
    isRegistering,
    isUpdating,
    editingFranquia,
    handleRegister,
    handleEditClick,
    handleUpdate,
    handleCancelEdit,
    registerSuccess,
    updateSuccess,
    registerError,
    updateError,
  } = useImileCadastroFranquia();

  useEffect(() => {
    if (registerSuccess) {
      toast({
        title: "Sucesso",
        description: "Franquia iMile cadastrada com sucesso!",
      });
    }
  }, [registerSuccess, toast]);

  useEffect(() => {
    if (updateSuccess) {
      toast({
        title: "Sucesso",
        description: "Franquia iMile atualizada com sucesso!",
      });
    }
  }, [updateSuccess, toast]);

  // A mensagem do backend importa aqui: as recusas de DS já cadastrada e de
  // colisão de ops só fazem sentido se o operador ler qual DS deu conflito.
  useEffect(() => {
    if (registerError) {
      toast({
        title: "Erro ao cadastrar",
        description:
          (registerError as any)?.response?.data?.message ||
          (registerError as Error)?.message ||
          "Ocorreu um erro ao cadastrar a franquia. Tente novamente.",
        variant: "destructive",
      });
    }
  }, [registerError, toast]);

  useEffect(() => {
    if (updateError) {
      toast({
        title: "Erro ao atualizar",
        description:
          (updateError as any)?.response?.data?.message ||
          (updateError as Error)?.message ||
          "Ocorreu um erro ao atualizar a franquia. Tente novamente.",
        variant: "destructive",
      });
    }
  }, [updateError, toast]);

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground">
          Cadastro de Franquias iMile
        </h1>
        <p className="text-muted-foreground mt-1">
          Cada franquia tem um prefixo e uma ou mais bases (DS). A ops de cada
          base é o prefixo + a DS, e é ela que casa com o romaneio.
        </p>
      </div>

      <div className="space-y-6">
        <RegistrationForm
          form={registrationForm}
          onSubmit={handleRegister}
          isSubmitting={isRegistering}
        />

        {isLoading ? (
          <LoadingCardSkeleton />
        ) : (
          <FranquiasTable
            franquias={franquias}
            onEditClick={handleEditClick}
          />
        )}

        <EditFranquiaDialog
          open={!!editingFranquia}
          franquia={editingFranquia}
          form={editForm}
          onSave={handleUpdate}
          onCancel={handleCancelEdit}
          isSaving={isUpdating}
        />
      </div>
    </div>
  );
}
